// extracted by mini-css-extract-plugin
export default {"container":"_2V0gN","list":"_10eCt","event":"_2-Vsu","title":"_1p2Di","chevron":"_2tPrs","info":"_3eT55","time":"_1DWey"};